/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Empty_TitleInputs */

const en_directory_category_empty_title = /** @type {(inputs: Directory_Category_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tools here yet`)
};

const zh_directory_category_empty_title = /** @type {(inputs: Directory_Category_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这里还没有工具`)
};

/**
* | output |
* | --- |
* | "No tools here yet" |
*
* @param {Directory_Category_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_empty_title = /** @type {((inputs?: Directory_Category_Empty_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Empty_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_empty_title(inputs)
	return zh_directory_category_empty_title(inputs)
});
export { directory_category_empty_title as "directory.category.empty_title" }